const baseUrl = import.meta.env.VITE_BASE_URL;
const fileUrl = import.meta.env.VITE_MEDIA_URL;
const googlePlaceKey = import.meta.env.VITE_GOOGLE_PLACE_API;
const stripePubKey = import.meta.env.VITE_STRIPE_KEY;
let spotifyClientId = import.meta.env.VITE_SPOTIFY_CLIENT_ID;
let spotifyAuthEndpoint = import.meta.env.VITE_SPOTIFY_AUTH_URL;

// Sent as `x-api-key` on the media/file upload endpoint.
const mediaApiKey = import.meta.env.VITE_MEDIA_API_KEY;

// Web Push VAPID public key — safe to expose, but sourced from env, never inlined.
// The Firebase Cloud Messaging *server* key that used to live here has been removed:
// topic subscribe/unsubscribe now happens on the backend (see utils/const.js).
const firebaseVapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY;

export const APP_FLOW_USER_AND_SPA = `https://d2bh8m1xn8trrc.cloudfront.net/common-app-side/MWMAppFlowVideo-UsersandSpas.mp4`;

export const GIFT_CARD_TUTORIAL = `https://d2bh8m1xn8trrc.cloudfront.net/common-app-side/MWMGiftCardTutorial.mp4`;

export const SPA_SETUP_TUTORIAL = `https://d2bh8m1xn8trrc.cloudfront.net/common-app-side/MWMSpaSetupTutorial-1741456622610.mp4`;

export const BOOK_NOW_TUTORIAL = `https://d2bh8m1xn8trrc.cloudfront.net/common-app-side/MWMTutorialforAddingaBookNowButtontoWebSite.mp4`;

export {
    baseUrl,
    fileUrl,
    firebaseVapidKey,
    googlePlaceKey,
    mediaApiKey,
    stripePubKey,
    spotifyClientId,
    spotifyAuthEndpoint,
};
